<template lang="html">
  <standard-dialog title='Select Rate'>
    <template #activator=' { on } '>
      <slot name='activator' :on='on'>
        <v-btn
          flat
          color='secondary'
          v-on='on'>
          Use a Different Rate
        </v-btn>
      </slot>
    </template>
    <template #main>
      <v-select
        label='Available Rates'
        :items='rates'
        :value='value'
        @input="$emit('input', $event)"/>
    </template>
    <template #actions=' { deactivate } '>
      <v-btn
        flat
        color='warning'
        v-on='deactivate'
        @click="$emit('input', null)">
        Cancel
      </v-btn>
      <!-- <create-rate-dialog @created="$emit('input', $event)"/> -->
      <v-btn
        flat
        color="primary"
        v-on="deactivate"
        :disabled="!value"
        @click="$emit('continue')">
        Continue
      </v-btn>
    </template>
  </standard-dialog>
</template>

<script>
import StandardDialog from './StandardDialog'
import CreateRateDialog from './CreateRateDialog'
export default {
  components: {
    'standard-dialog': StandardDialog,
    'create-rate-dialog': CreateRateDialog
  },
  props: {
    value: {
      default: null
    },
    rates: {
      type: Array,
      default: () => ([])
    }
  }
}
</script>

<style lang="css" scoped>
</style>
